import React from 'react';
import { CompassIcon } from 'lucide-react';
import { channel } from '../data/channel';
const links = [{
  href: `${channel.url}/videos`,
  label: 'Відео'
}, {
  href: `${channel.url}/playlists`,
  label: 'Плейлисти'
}, {
  href: `${channel.url}/shorts`,
  label: 'Shorts'
}, {
  href: `${channel.url}/about`,
  label: 'Про канал'
}];
export function SiteFooter() {
  return <footer className="bg-ink pb-24 pt-14 sm:pb-14" data-id="element-127" data-mp="3dguvx64qv0bh">
      <div className="mx-auto flex max-w-7xl flex-col gap-8 px-5 md:flex-row md:items-center md:justify-between md:px-8" data-id="element-128" data-mp="3dhmi5qcgblp3">
        <div className="flex items-center gap-2.5" data-id="element-129" data-mp="38juniokf9lh7">
          <span className="flex h-9 w-9 items-center justify-center rounded-full bg-ember text-ember-ink" data-id="element-130" data-mp="33hvlpj4bywmd">
            <CompassIcon className="h-5 w-5" aria-hidden="true" data-id="element-131" data-mp="2yknak2hlnsum" />
          </span>
          <div data-id="element-132" data-mp="11rtrzey50yrg">
            <p className="font-display text-base font-semibold" data-id="element-133" data-mp="11q90xzb17xyc">{channel.name}</p>
            <p className="text-sm text-muted" data-id="element-134" data-mp="wrz4lldkmrb5">{channel.handle} на YouTube</p>
          </div>
        </div>
        <nav aria-label="Канал на YouTube" data-id="element-135" data-mp="15qlr61u9fmln">
          <ul className="flex flex-wrap gap-x-7 gap-y-2" data-id="element-136" data-mp="15sy7yboa7qx4">
            {links.map(link => <li key={link.label} data-id="element-137" data-mp="1ar9fugv0nrcp">
                <a href={link.href} target="_blank" rel="noopener noreferrer" className="text-sm font-semibold text-paper/80 transition-colors duration-150 hover:text-paper" data-id="element-138" data-mp="vsxlwhz12wp8">
                  {link.label}
                </a>
              </li>)}
          </ul>
        </nav>
        <div className="flex flex-col gap-1 md:items-end" data-id="element-139" data-mp="1tiafz87vhsxu">
          <a href={`mailto:${channel.email}`} className="text-sm font-semibold text-paper transition-colors duration-150 hover:text-ember" data-id="element-140" data-mp="1eqs1xfykq8h4">
            {channel.email}
          </a>
          <p className="text-sm text-muted" data-id="element-141" data-mp="27ewac98j4zni">© {new Date().getFullYear()} {channel.name}</p>
        </div>
      </div>
    </footer>;
}